import { Wrap } from './styles';

import Icon from '@map/components/Icons';
import Paper from '@material-ui/core/Paper';
import MobileSwipeableDialog from 'components/MobileSwipeableDialog';
/**
 * useState é um hook que nos permite rastrear o estado em um
 * componente de função, o estado geralmente se refere a dados ou
 * propriedads que precisam ser rastreador em um aplicativo.
 * 
 * useEffect é um hook que permite executar efeitos colaterais em
 * seus componentes, por exemplo: buscar dados, atualizar diretamente
 * o DOM e cronômetros, ele aceita dois argumentos o segundo é opcional.
 */
import { useState, useEffect } from 'react';

/**
 *
 * BottomPanel
 * É o painel que aparece embaixo com a tabela de atributos,
 * por exemplo, mas seu conteúdo pode ser alterado, utilizando
 * esse componenete como Wrap
 *
 */
export const BottomPanel = ({
  menuPanelIsHided,
  hideMenuPanel,
  title,
  onClose,
  children,
}) => {
  const [expandLevel, setExpandLevel] = useState(2);
  const [showMobile, setShowMobile] = useState(window.innerWidth <= 768);

  const maxExpandLevel = 3;
  const minExpandLevel = 1;

  useEffect(() => {
    const handleMobile = () => setShowMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleMobile);
    return () => window.removeEventListener('resize', handleMobile);
  }, []);

  return (
    <Wrap expandLevel={expandLevel} expandLeft={menuPanelIsHided}>
      {showMobile ? (
        <MobileSwipeableDialog
          startHeight={200}
          title={title}
          onClose={onClose}
        >
          {children}
        </MobileSwipeableDialog>
      ) : (
        <Paper square variant="outlined" className="bottom-panel">
          <button
            className="button left-arrow"
            onClick={() => hideMenuPanel(!menuPanelIsHided)}
          >
            <Icon i="map-bottompanel-arrow" />
          </button>
          <button
            className="button top-arrow-up"
            onClick={() => {
              expandLevel < maxExpandLevel && setExpandLevel(expandLevel + 1);
            }}
          >
            <Icon i="map-bottompanel-arrow" />
          </button>
          <button
            className="button top-arrow-down"
            onClick={() => {
              expandLevel > minExpandLevel && setExpandLevel(expandLevel - 1);
            }}
          >
            <Icon i="map-bottompanel-arrow" />
          </button>
          <button
            className="button close"
            onClick={() => {
              hideMenuPanel(false);
              onClose();
            }}
          >
            <Icon i="map-bottompanel-close" />
          </button>
          {children}
        </Paper>
      )}
    </Wrap>
  );
};

BottomPanel.properties = {
  ignore: true,
};

export default BottomPanel;
